<template>
  <div class="login_up">
    <!-- <div class="registerBox" v-show="isRegisterBox"> -->
    <h4>{{title}}</h4>
    <el-form v-show="registrationMethod" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="0px"
      class="ruleForm">
      <p style="float:left;">手机号</p>
      <el-form-item label prop="loginName">
        <el-input autocomplete="off" v-model.number="ruleForm.loginName"></el-input>
      </el-form-item>
      <p style="float:left;">密码</p>
      <el-form-item label prop="password">
        <el-input type="password" v-model="ruleForm.password" autocomplete="off" show-password></el-input>
      </el-form-item>
      <p style="text-align: left;">验证码</p>
      <el-form-item label prop="numCode" class="verification">
        <el-col :span="13">
          <el-input v-model="ruleForm.numCode" autocomplete="off"></el-input>
        </el-col>
        <el-col class="line" :span="1">&nbsp;</el-col>
        <el-col :span="10">
          <button type="button" @click="getVerificationCode('ruleForm')" :disabled="disabled">{{verificationCode}}
            <span v-if="ver">秒后重试</span>
          </button>
        </el-col>
      </el-form-item>

      <!-- <p class="passHint" style="float:left">*密码长度不能超过16个字符</p> -->
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">注册</el-button>
      </el-form-item>
    </el-form>
    <el-form v-show="!registrationMethod" :model="ruleFormEmail" status-icon :rules="rulesEmail" ref="ruleFormEmail"
      label-width="0px" class="ruleForm">
      <p style="float:left;">邮箱</p>
      <el-form-item label prop="email">
        <el-input autocomplete="off" v-model="ruleFormEmail.email"></el-input>
      </el-form-item>
      <p style="float:left;">密码</p>
      <el-form-item label prop="password">
        <el-input type="password" v-model="ruleFormEmail.password" autocomplete="off" show-password></el-input>
      </el-form-item>
      <p style="text-align: left;">验证码</p>
      <el-form-item label prop="numCode" class="verification">
        <el-col :span="13">
          <el-input v-model="ruleFormEmail.numCode" autocomplete="off"></el-input>
        </el-col>
        <el-col class="line" :span="1">&nbsp;</el-col>
        <el-col :span="10">
          <button type="button" @click="getVerificationCode('ruleFormEmail')"
            :disabled="disabledEmail">{{verificationCodeEmail}}
            <span v-if="verEmail">秒后重试</span>
          </button>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button v-if="registrationMethod" type="primary" @click="submitForm('ruleForm')">注册</el-button>
        <el-button v-if="!registrationMethod" type="primary" @click="submitForm('ruleFormEmail')">注册</el-button>
      </el-form-item>
    </el-form>
    <div class="go_back">
      <span @click="register">{{skip}}</span>
      <span @click="goBack">已有账号，去登录</span>
    </div>
    <p style="color:#7F7F7F;font-size:12px;margin-top: 10px;">点击“注册”表明您已阅读并同意<a style="color:#204BA3" :href="serveUrl"
        target="_blank">服务条款</a></p>
    <!-- </div> -->
  </div>
</template>

<script>
import { setTimeout } from "timers";
import md5 from "js-md5";
// import myTitle from '@/common/title.vue'

export default {
  name: "login_register",
  data () {
    var username = (rule, value, callback) => {
      let reg = /^1\d{10}$/;
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      if (!reg.test(value)) {
        return callback(new Error("手机号不正确"));
      }
      callback();
    };
    var userEmail = (rule, value, callback) => {
      let reg = /[A-z]+[A-z0-9_-]*\\@[A-z0-9]+\\.[A-z]+/;
      if (!value) {
        return callback(new Error("邮箱不能为空"));
      }
      if (!reg.test(value)) {
        return callback(new Error("邮箱不正确"));
      }
      callback();
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码长度不能小于6个字符"));
      } else if (value.length > 16) {
        callback(new Error("密码长度不能超过16个字符"));
      }
      callback();
    };
    var verify = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("验证码不能为空"));
      }
      callback();
    };
    return {
      ruleForm: {
        loginName: "",
        password: "",
        verification: "",
        numCode: "",
        email: this.registrationMethod ? null : "",
        _load: false
      },
      rules: {
        loginName: [{ required: true, validator: username, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        numCode: [{ validator: verify, trigger: "blur" }]
        // age: [{ validator: checkAge, trigger: "blur" }]
      },
      ruleFormEmail: {
        email: "",
        password: "",
        verification: "",
        numCode: "",
        _load: false
      },
      rulesEmail: {
        email: [{ required: true, message: '请输入邮箱地址', trigger: 'blur' },
        { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: "blur" }],
        numCode: [{ validator: verify, trigger: "blur" }]
        // age: [{ validator: checkAge, trigger: "blur" }]
      },
      verificationCode: "获取验证码",
      verificationCodeEmail: "获取验证码",
      disabled: false,
      disabledEmail: false,
      ver: false,
      verEmail: false,
      registrationMethod: true,// 注册方式
      serveUrl: ""
    };
  },
  computed: {
    skip () {
      return this.registrationMethod ? "邮箱注册" : "手机号注册"
    },
    title () {
      return this.registrationMethod ? "手机号注册" : "邮箱注册"
    },
  },
  created () { 
    process.env.NODE_ENV == 'production' ? this.serveUrl = "https://gen.fycat.com/h5/serveClause.html" : this.serveUrl = "http://dev.anylangtech.com/cat-web/h5/serveClause.html"
  },
  methods: {
    // 切换注册方式
    register () {
      if (this.registrationMethod) {
        this.$refs['ruleFormEmail'].resetFields();
        this.$refs['ruleForm'].resetFields();
        this.registrationMethod = !this.registrationMethod
      } else {
        this.$refs['ruleFormEmail'].resetFields();
        this.$refs['ruleForm'].resetFields();
        this.registrationMethod = !this.registrationMethod
      }
    },
    // 上一步
    goBack () {
      this.$emit("func", 0)
      // this.$router.go(-1)
    },
    submitForm () {
      let that = this;
      if (this.registrationMethod) {
        let verify = true
        this.$refs.ruleForm.validateField(["loginName", "numCode", "password"], errTip => {
          if (errTip) {
            // 会调用多次    numCode: '',

            verify = false;
            return
          }
        });
        if (verify) {
          let params = {
            loginPhone: this.ruleForm.loginName,
            password: md5(this.ruleForm.password),
            verificationCode: this.ruleForm.numCode
          }
          this.catReq1Service("/user/user_register_telephone", params) // /api/v1/user/update
            .then(response => {
              if (!response.success) {
                return;
              }
              response.result.pwd = that.ruleForm.password
              that.$emit("func", 3, { userInfo: response.result })
              // that.$emit("func", 3, { userInfo: that.$Base64.encode(JSON.stringify(response.result)) })
              // that.$router.push({ name: "wxAddress", query: { userInfo: that.$Base64.encode(JSON.stringify(response.result)) } })
            })
            .catch(error => {
            });
        }

      } else {
        let verifyE = true
        this.$refs.ruleFormEmail.validateField(["email", "numCode", "password"], errTip => {
          if (errTip) {
            // 会调用多次    numCode: '',

            verifyE = false;
            return
          }
        });

        if (verifyE) {
          let params = {
            email: this.ruleFormEmail.email,
            password: md5(this.ruleFormEmail.password),
            verificationCode: this.ruleFormEmail.numCode
          }
          this.catReq1Service("/user/user_register_email", params) // /api/v1/user/update
            .then(response => {
              if (!response.success) {
                return;
              }
              response.result.pwd = that.ruleFormEmail.password
              that.$emit("func", 3, { userInfo: response.result })
              // that.$router.push({ name: "wxAddress", query: { userInfo: that.$Base64.encode(JSON.stringify(response.result)) } })
            })
            .catch(error => {
            });
        }

      }

    },
    // 获取验证码
    getVerificationCode () {
      var verify = true;
      var verifyEmail = true;
      if (this.registrationMethod) {
        this.$refs.ruleForm.validateField(["loginName"], errTip => {
          if (errTip) {
            // 会调用多次
            verify = false;
          }
        });
      } else {
        this.$refs.ruleFormEmail.validateField(["email"], errTip => {
          if (errTip) {
            // 会调用多次
            verify = false;
          }
        });
      }

      if (verify) {
        if (this.registrationMethod) {
          this.ver = true // 显示span
          let timeCounter;
          this.disabled = true;
          this.verificationCode = 60;
          if (this.verificationCode < 0) {
            clearTimeout(timeCounter);
            this.disabled = false;
            this.ver = false
            this.verificationCode = "获取验证码";
          }
          timeCounter = setInterval(() => {
            this.verificationCode--;

            if (this.verificationCode < 0) {
              clearTimeout(timeCounter);
              this.disabled = false;
              this.ver = false
              this.verificationCode = "重新获取验证码";

            }
          }, 1000);
          let params = {
            loginPhone: this.ruleForm.loginName
          }
          this.catReq1Service("/user/send_verifyCode", params).then(response => {
            if (!response.success) {
              this.disabled = false;
              this.verificationCode = 0
              this.verificationCode = "获取验证码";
              clearTimeout(timeCounter);
              this.ver = false
              return;
            }
            callback && callback(this.scopedForm);
          })
            .catch(error => {
            });
        } else {
          this.verEmail = true // 显示span
          let timeCounter;
          this.disabledEmail = true;
          this.verificationCodeEmail = 60;
          if (this.verificationCodeEmail < 0) {
            clearTimeout(timeCounter);
            this.disabledEmail = false;
            this.verEmail = false
            this.verificationCode = "获取验证码";
          }
          timeCounter = setInterval(() => {
            this.verificationCodeEmail--;

            if (this.verificationCodeEmail < 0) {
              clearTimeout(timeCounter);
              this.disabledEmail = false;
              this.verEmail = false
              this.verificationCodeEmail = "重新获取验证码";

            }
          }, 1000);
          let params = {
            email: this.ruleFormEmail.email,
            platformType: 0
          }
          this.catReq1Service("/user/send_email_code", params).then(response => {
            if (!response.success) {
              this.disabledEmail = false;
              this.verificationCode = 0
              this.verificationCode = "获取验证码";
              clearTimeout(timeCounter);
              this.ver = false
              return;
            }
            callback && callback(this.scopedForm);
          })
            .catch(error => {

            });
        }
        ///user/send_email_code

      }

    }
  }
};
</script>
<style lang="less" scoped>
.login_up {
  text-align: center;
  // width: 300px;
  // height: 100%;
  background: #ffffff;
  // -webkit-box-shadow: 0px 10px 10px 0px rgba(137, 137, 137, 0.13);
  // box-shadow: 0px 10px 10px 0px rgba(137, 137, 137, 0.13);
  border-radius: 10px;
  padding: 70px 80px 0 80px;
  position: relative;
  h4 {
    text-align: center;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
  }
  .ruleForm {
    margin-top: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    p {
      margin-bottom: 5px;
    }
    /deep/.el-input__inner {
      height: 36px;
      line-height: 36px;
      border: 1px solid rgba(192, 192, 192, 1);
      border-radius: 2px;
    }
    .verification {
      button {
        // position: relative;
        // left: 0px;
        width: 94%;
        height: 34px;
        background: #5589eb;
        // border: 1px solid #454545;
        border-radius: 2px;
        color: white;
      }
      // button:hover {
      //   background: #f1f1f1;
      //   border: 1px solid #454545;
      //   color: #454545;
      // }
      // button:active {
      //   background: #454545;
      //   color: #ffffff;
      // }
    }
    button {
      width: 100%;
      height: 36px;
      background: #216fe5;
      border: none;
      // border-radius: 18px;
      line-height: 0px;
    }
    // button:hover {
    //   background: #3e3e3e;
    // }
    // button:press {
    //   background: #333333;
    // }
    .register {
      background: #454545;
      // border: 1px solid rgba(192, 192, 192, 1);
      color: rgba(69, 69, 69, 1);
    }
    .el-form-item {
      margin-bottom: 20px;
    }
    .passHint {
      position: relative;
      top: -12px;
    }
  }
  .go_back {
    display: flex;
    justify-content: space-between;
    font-family: Microsoft YaHei;
    font-size: 12px;
    font-weight: 400;
    color: #454545;
    margin-top: -12px;
    span {
      cursor: pointer;
    }
  }
}
</style>